import { debounce } from 'lodash';

const matchHeights = (elems, useMax = true) => {
  const heights = [...elems].map(elem => {
    // Clear the previous inline height incase window resized and re-calc needs to happen
    // Using this loop to save an additional loop through all elements.
    if (elem.style.height) {
      elem.removeAttribute('style');
    }

    // Return the offsetHeight to create array of all heights.
    return elem.offsetHeight;
  });

  const getHighest = Math.max(...heights);
  const getShortest = Math.min(...heights.filter(height => height > 128));
  const matchedHeight = useMax ? getHighest : getShortest;

  elems.forEach(elem => {
    // Check highest and shortest are't the same to fix oversized card bug
    if (getHighest !== getShortest) {
      elem.setAttribute('style', `height: ${matchedHeight}px`);
    }
  });
};

const triggerMatchHeights = () => {
  const cardLists = document.querySelectorAll('.cardItem-list');

  // Make sure columnList doesn't include cardList too to prevent looping over twice.
  const columnLists = document.querySelectorAll('.wp-block-twoyou-columns:not(.cardItem-list)');

  cardLists.forEach(elem => {
    const bodyItems = elem.querySelectorAll('.cardItem-body');
    const figureItems = elem.querySelectorAll('.cardItem-figure');

    matchHeights(bodyItems);
    matchHeights(figureItems, false);
  });

  columnLists.forEach(elem => {
    const headerItems = elem.querySelectorAll('.cardItem-header');

    matchHeights(headerItems);
  });
};

document.addEventListener('DOMContentLoaded', triggerMatchHeights);
window.addEventListener('resize', debounce(triggerMatchHeights, 300));

// Use window.onload to update on images loading in also.
window.onload = triggerMatchHeights;
